import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { RootState } from "../../../setup";
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay";
import { SubscriptionModel } from "../../modules/auth/models/SubscriptionModel";
import { createMastermindCircle, createOpenDiscussion, updateMastermindCircle, updateOpenDiscussion } from "../../services/communityService";
import { CommunityMastermindForm } from "./components/CommunityMastermindForm";
import { CommunityOpenDiscussForm } from "./components/CommunityOpenDiscussForm";
import { CommunitySelector } from "./components/CommunitySelector";
import { CommunityFormEnum } from "./enums/CommunityFormEnum";
import { CommunitySubEnum } from "./enums/CommunitySubEnum";
import { CommunityMastermindCreateModel } from "./models/CommunityMastermindCreateModel";
import { CommunityOpenDiscussCreate } from "./models/CommunityOpenDiscussCreate";


const CommunityFormPage = () => {
    const { pathname, search } = useLocation();
    const isEdit = pathname.includes('/edit/');
    const sub = useSelector<RootState>(({auth}) => auth.subscription, shallowEqual) as SubscriptionModel;
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [ type, setType ] = useState<CommunityFormEnum | null>(null);

    useEffect(() => {
        document.body.classList.add('community-form-wrapper')
        return () => document.body.classList.remove('community-form-wrapper')
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(search); 
        const _defaulType = params.get("type");
        if(_defaulType === '1') {
            setType(CommunityFormEnum.OPEN_DISCUSSION)
            return;
        }

        if((sub?.plan as any)?.title !== CommunitySubEnum.ElectiPlus)
            return;

        if(_defaulType === '2')
            setType(CommunityFormEnum.MASTERMIND_CIRCLE)

    }, [search]);

    const _createMastermindDiscuss = (form: CommunityMastermindCreateModel, id?: string | number) => {
        const _fetch = async () => {
            try {
                setLoading(true);
                const _tags = form.tags.map(t => t.value as string);
                const _invites = form.invites.map(i => i.value.id) as number[];
                if(id)
                    await updateMastermindCircle(id, form.topic, form.content, _tags, _invites, form.facilitator);
                else
                    await createMastermindCircle(form.topic, form.content, _tags, _invites, form.facilitator);
                history.replace(`/community/success?type=${type}`);
            }
            catch {}
            finally {
                setLoading(false);
            }
        }
        _fetch();
    }

    const _createOpenDiscuss = (form: CommunityOpenDiscussCreate, id?: string | number) => {
        const _fetch = async () => {
            try {
                setLoading(true);
                if(id)
                    await updateOpenDiscussion(id.toString(), form.topic, form.description, form.tags.map(t => t.label));
                else
                    await createOpenDiscussion(form.topic, form.description, form.tags.map(t => t.label));
                history.replace(`/community/success?type=${type}`);
            }
            catch { 
                
            }
            finally {
                setLoading(false);
            }
        }
        _fetch();
    }

    return (
        <>
            <LoaderOverlay visible={loading} message={'Loading...'} />
            <div className="community-form">
                <div className="w-100 tap-flex-center justify-content-start">
                    <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.push('/community')}>
                        Back
                    </div>
                </div>
                <div className="d-flex flex-column" style={{gap: '10px'}}>
                    <h3>
                        Community 
                    </h3>
                    <p>
                        You are among the world’s brightest minds. Here, the space is open for you to share, exchange, and grow—whether in open discussions or exclusive mastermind circles.
                    </p>
                </div>

                <CommunitySelector 
                    onSelect={(id) => setType(id)}
                    selection={type}
                    subs={(sub?.plan as any)?.title}
                    isEdited={isEdit}
                />
                {type === CommunityFormEnum.OPEN_DISCUSSION ? (
                    <CommunityOpenDiscussForm onSubmit={_createOpenDiscuss}/>
                ):(
                    <CommunityMastermindForm onSubmit={_createMastermindDiscuss}/>
                )}
            </div>
        </>
    )
}

export default CommunityFormPage;